'use es6';

import http from 'hub-http/clients/apiClient';
import { Map as ImmutableMap } from 'immutable';
import { formatToReferencesList } from 'reference-resolvers/lib/formatReferences';
import get from 'transmute/get';
const formatAutomatedEmails = formatToReferencesList({
  getId: get('id'),
  getLabel: get('name')
});
export const createGetAutomatedEmailsByIds = ({
  httpClient
}) => sourceApp => (ids = []) => {
  return httpClient.get('cosemail/v1/emails/search/automated-with-ticket-and-deal/multi', {
    query: {
      emailId: ids,
      sourceApp
    }
  }).then(formatAutomatedEmails);
};
export const getAutomatedEmailsByIds = createGetAutomatedEmailsByIds({
  httpClient: http
});
export const createGetAutomatedEmailsSearchPage = ({
  httpClient
}) => opts => {
  // Array.from works on Immutable Lists and JS arrays.
  const emailTypes = get('emailTypes', opts) && Array.from(get('emailTypes', opts));
  const clientTimeout = get('clienttimeout', opts);
  return httpClient.get('cosemail/v1/emails/search/automated-with-ticket-and-deal', Object.assign({
    query: Object.assign({
      emailSortField: get('emailSortField', opts),
      emailTypes,
      limit: get('count', opts) || 100,
      offset: get('offset', opts) || 0,
      q: get('query', opts) || '',
      sortOrder: get('sortOrder', opts),
      sourceApp: get('sourceApp', opts)
    }, clientTimeout ? {
      clientTimeout
    } : {})
  }, clientTimeout ? {
    timeout: clientTimeout
  } : {})).then(({
    hasMore,
    offset,
    results = []
  }) => ImmutableMap({
    count: results.length,
    hasMore,
    // NOTE(bheng): This API returns the offset provided, not the next one.
    offset: offset + results.length,
    results: formatAutomatedEmails(results)
  }));
};
export const getAutomatedEmailsSearchPage = createGetAutomatedEmailsSearchPage({
  httpClient: http
});